import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    placeholder: string;
    EMPTY: string;
    LOADING: string;
    ERROR: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for the search input field */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch.placeholder?c=khpwlpz0usk4", defaultMessage: "Search for assets, folders, and projects" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displayed when no search results are found */
            EMPTY: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch.EMPTY?c=2cteahvyfroz8", defaultMessage: "No matches found." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displayed while search results are loading */
            LOADING: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch.LOADING?c=57512ik3sq66", defaultMessage: "Loading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displayed when an error occurs while fetching search results */
            ERROR: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch.ERROR?c=1ijusvs417frs", defaultMessage: "Failed to load results" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
